import type { CountryFlag } from '@api-client/info-services';
import type { Country } from '@api-client/payments';

export function getSafeCountryName(
    countries: Country[],
    countryIso: string | undefined,
): string | undefined {
    const country = countries.find(({ countryIso: iso }) => iso === countryIso);

    return country?.name ?? countryIso;
}

export const COUNTRY_FLAG: Record<string, CountryFlag> = {
    EUROPEAN_UNION_COUNTRY: 'europeanUnionCountry',
    ONLINE_PURCHASE_NOT_ALLOWED: 'onlinePurchaseNotAllowed',
    REPORTING_TAX_INFO_REQUIRED: 'reportingTaxInfoRequired',
    TAX_RESIDENCE_READ_ONLY: 'taxResidenceReadOnly',
    TAX_RESIDENCE_ALTERNATIVE_OPTIONS: 'taxResidenceAlternativeOptions',
};
